import {BaseModule} from './base.module';

export class UTMModule extends BaseModule {
    constructor() {
        console.log('UTMModule: Constructor initialized');
        super();
        this.UTMParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        this.storageKey = 'jb_utm_params';
        console.log('UTMModule: UTM params initialized:', this.UTMParams);
        console.log('UTMModule: Storage key set to:', this.storageKey);

        window.utmModule = this;
        console.log('UTMModule: Module exposed to window.utmModule');
    }

    initialize() {
        console.log('UTMModule: Initializing module');
        document.addEventListener("anonymous-analytics-cookies-accepted", () => {
            console.log('UTMModule: anonymous-analytics-cookies-accepted event triggered');
            this.onAnonymousAnalyticsCookiesAccepted();
        });
        document.addEventListener("anonymous-analytics-cookies-declined", () => {
            console.log('UTMModule: anonymous-analytics-cookies-declined event triggered');
            this.onAnonymousAnalyticsCookiesDeclined();
        });

        // deprecated
        console.log('UTMModule: Checking for existing cookie acceptance');
        if (document.cookie.indexOf('ckaccept=1') !== -1) {
            console.log('UTMModule: Cookie already accepted, calling onAnonymousAnalyticsCookiesAccepted');
            this.onAnonymousAnalyticsCookiesAccepted();
        } else {
            console.log('UTMModule: Cookie not yet accepted, waiting for acceptance');
        }
    }

    onAnonymousAnalyticsCookiesAccepted() {
        console.log('UTMModule: anonymous research cookies accepted, processing UTM handling');
        console.log('UTMModule: Capturing UTM parameters');
        this.captureUTMParameters();
        console.log('UTMModule: Adding form submission handlers');
        this.addFormSubmissionHandlers();
    }

    onAnonymousAnalyticsCookiesDeclined() {
        console.log('UTMModule: anonymous research cookies declined, processing UTM handling');
        this.removeFormSubmissionHandlers();
    }

    captureUTMParameters() {
        console.log('UTMModule: Starting UTM parameter capture');
        const urlParams = new URLSearchParams(window.location.search);
        console.log('UTMModule: URL parameters:', window.location.search);

        const utmData = {};
        console.log('UTMModule: Checking for UTM parameters in URL');

        this.UTMParams.forEach(param => {
            const value = urlParams.get(param);
            console.log(`UTMModule: Checking ${param}:`, value);
            if (value) {
                utmData[param] = value;
                console.log(`UTMModule: Found ${param}=${value}`);
            }
        });

        console.log('UTMModule: Collected UTM data:', utmData);
        if (Object.keys(utmData).length > 0) {
            console.log('UTMModule: Storing UTM data in sessionStorage');
            sessionStorage.setItem(this.storageKey, JSON.stringify(utmData));
            console.log('UTMModule: UTM data stored successfully');
        } else {
            console.log('UTMModule: No UTM parameters found, nothing stored');
        }
    }

    addFormSubmissionHandlers() {
        console.log('UTMModule: Setting up form submission event listener');
        document.addEventListener('submit', this.boundSubmitEventHandler.bind(this));
        console.log('UTMModule: Form submission handler added');
    }

    removeFormSubmissionHandlers() {
        console.log('UTMModule: Removing form submission event listener');
        document.removeEventListener('submit', this.boundSubmitEventHandler.bind(this));
        console.log('UTMModule: Form submission handler added');
    }

    boundSubmitEventHandler(event) {
        console.log('UTMModule: Form submission detected');
        const form = event.target;
        console.log('UTMModule: Processing form:', form);
        this.addUTMParamsToForm(form);
    }

    addUTMParamsToForm(form) {
        console.log('UTMModule: Adding UTM params to form', form);

        if (form.dataset.utmProcessed === 'true') {
            console.log('UTMModule: Form already processed, skipping');
            return;
        }

        const UTMParams = this.getUTMParameters();
        console.log('UTMModule: Retrieved UTM parameters:', UTMParams);

        Object.entries(UTMParams).forEach(([key, value]) => {
            console.log(`UTMModule: Processing parameter ${key}=${value}`);
            if (!form.querySelector(`input[name="${key}"]`)) {
                console.log(`UTMModule: Input for ${key} not found, creating new input`);
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                console.log(`UTMModule: Adding hidden input ${key}=${value}`);
                form.appendChild(input);
            } else {
                console.log(`UTMModule: Input for ${key} already exists, skipping`);
            }
        });

        // Mark the form as processed
        console.log('UTMModule: Marking form as processed');
        form.dataset.utmProcessed = 'true';
        console.log('UTMModule: Form processing complete');
    }

    getUTMParameters() {
        console.log('UTMModule: Getting stored UTM parameters');
        const storedParams = sessionStorage.getItem(this.storageKey);
        console.log('UTMModule: Raw stored params:', storedParams);

        const result = storedParams ? JSON.parse(storedParams) : {};
        console.log('UTMModule: Parsed UTM parameters:', result);
        return result;
    }
}